import React, { useState, useEffect, useRef, useLayoutEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { getAdminBarganTerm, addAdminBarganTerm, deleteAdminBarganTerm, updateAdminBarganTerm } from "../../redux/actions/barganPaymentTerm.action";
import { getDefaultCompany, getOneDefaultCompany } from "../../redux/actions/defaultCompany";
import { getCompanyAccess, updateCompanyAccess, deleteCompanyAccess, getAllCompany, createCompanyAccess } from "../../redux/actions/companyAccess"
import { getLog } from "../../redux/actions/log.action"
import { getRights } from "../../redux/actions/userRights.action";

import PageHeader from "../../components/PageHeader/PageHeader"
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import Tables from "../../components/Table/Tables"
import { ReadCookie } from "../../utils/readCookie";
import { Button, Row, Col, Form, Input, Checkbox, Tabs, Tooltip, Popconfirm, Modal, Divider } from 'antd';
import { CloseCircleOutlined, DeleteOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { logColumns, barganPaymentTermColumns } from "../../utils/cols";
import notification from '../../utils/notification';
import "../Style/style.css";
import { TabTitle } from '../../utils/GeneralFunction';

const { TabPane } = Tabs;

export default function BarganPaymentTerm({ token }) {
    TabTitle("Bergan Payment Term")
    const menuId = ReadCookie('menuId')
    const dCompanyId = ReadCookie('defaultCompany')
    const barganPaymentTermNameInput = useRef(null);      
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm();
    const [barganPaymentTermObj, setBarganPaymentTermObj] = useState(null);
    const dispatch = useDispatch();
    const { barganPaymentTerm, log, userRights } = useSelector(state => state)
    const [minimize, setMinimize] = useState(false);
    const [check, setCheck] = useState(false);
    const [barganPaymentTermName, setBarganPaymentTermName] = useState('');
    const [disable, setDisable] = useState(false);
    const [formState, setFormState] = useState('view');

 

    
    useEffect(() => {
        dispatch(getAdminBarganTerm(token, menuId));
        // dispatch(getLog(token));
        dispatch(getLog(token, { admin_bergen_payment_term: "admin_bergen_payment_term"}))
      }, [token]);

    useEffect(() => {
        dispatch(getAdminBarganTerm(token, menuId))
    }, [token])

    useLayoutEffect(() => {
        dispatch(getRights(token, menuId)).then((res) => {
            if (res.type === "GET_USER_RIGHTS_SUCCESS") {
                if (!res?.payload.can_add) {
                    setFormState("table")
                }
            }
        });
    }, [])

    useEffect(() => {

        if (barganPaymentTermObj) {
            setFormState('view')
            form.setFieldsValue({
                id: barganPaymentTermObj.bergen_payment_term_id,
                barganPaymentTermType: barganPaymentTermObj.term_description,
                active: barganPaymentTermObj.is_active
            });
            setBarganPaymentTermName(barganPaymentTermObj.term_description)
            setCheck(barganPaymentTermObj.is_active)
            dispatch(getCompanyAccess(token, barganPaymentTermObj.bergen_payment_term_id, menuId))

        }
    }, [barganPaymentTermObj]);

    useEffect(() => {
        if (barganPaymentTermName === '') {
            setDisable(true)
        } else {
            setDisable(false)
        }
    }, [barganPaymentTermName])


    const handleTab = (key) => {
        if (key === "logs") {
            // data: { admin_bergen_payment_term: "admin_bergen_payment_term", admin_company_entity_access: "admin_company_entity_access" }
            dispatch(getLog(token, { admin_bergen_payment_term: "admin_bergen_payment_term"}))
        }
    }


    const formSave = () => {
        if (formState === "add") {
            dispatch(addAdminBarganTerm(token, { barganPaymentTermName, check }, menuId)).then((res) => {

                if (res.type === "ADD_BARGAN_PAYMENT_TERM_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data)
                }
                if (res.type === "ADD_BARGAN_PAYMENT_TERM_SUCCESS") {
                    let data = {
                        company_id: dCompanyId
                    }
                    notification("success", "Bargan Payment Term Type Created", "Bargan Payment Term Type created successfully!");
                    form.setFieldsValue({
                        barganPaymentTermType: ""
                    })
                    setFormState("")
                    // setCheck(false)
                    setBarganPaymentTermName("")
                    setBarganPaymentTermObj(null)
                }
                dispatch(getAdminBarganTerm(token, menuId))

            })

        }

        if (formState === "edit") {
            dispatch(updateAdminBarganTerm(token, { barganPaymentTermName, check }, barganPaymentTermObj.bergen_payment_term_id)).then((res) => {
                if (res.type === "UPDATE_BARGAN_PAYMENT_TERM_ERROR") {
                    notification("error", "Update", "Something went wrong")
                }
                if (res.type === "UPDATE_BARGAN_PAYMENT_TERM_SUCCESS") {
                    notification("success", "Bargan Payment Term Type Updated", "Record updated successfully")
                }
                dispatch(getAdminBarganTerm(token, menuId))
            })


        }


    }

    const handleDelete = () => {
        if (barganPaymentTermObj) {
            dispatch(deleteAdminBarganTerm(token, barganPaymentTermObj.bergen_payment_term_id)).then((res) => {
                if (res.type === "DELETE_BARGAN_PAYMENT_TERM_SUCCESS") {
                    notification("success", "Bargan Payment Term Type Deleted", "Record deleted successfully!");
                }
                if (res.type === "DELETE_BARGAN_PAYMENT_TERM_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data);
                }
                form.setFieldsValue({
                    barganPaymentTermType: ""
                })
                // setCheck(false)
                setBarganPaymentTermName("")
                setBarganPaymentTermObj(null)
                setFormState('')
                dispatch(getAdminBarganTerm(token, menuId))

            })
        }
    }
    useEffect(() => {
        if (formState === "add") {
            dispatch(getOneDefaultCompany(token, dCompanyId));
            barganPaymentTermNameInput.current.focus();
            form.setFieldsValue({
                barganPaymentTermType: ""
            })
            setCheck(true)
            setBarganPaymentTermName("")
            setBarganPaymentTermObj(null)
        }
    }, [formState]);

    const filterReset = () => {
        setFormState("view")
    }
    return (
        <div className='styleContainer' >
            <div className='styleBody h-100'  >
                <PageHeader title={"Bargan Payment Term"} minimize={setMinimize} check={minimize} />
                {
                    !minimize &&
                    <div className='bodyStyle' >
                        <div className='crudDiv' ><CrudButtons rights={userRights?.payload} reset={filterReset} formType={formState} save={formSave} disable={disable} formState={setFormState} onDelete={handleDelete} /></div>

                        <div className='styleContent' >
                            <Row className='tables-main-row-new' >
                            <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                                    <div className='styleTable' >
                                        <Tables type="barganPaymentTerm" barganPaymentTermObj={setBarganPaymentTermObj} scrollX={"20rem"} scroll={602} perPage={25} source={barganPaymentTerm?.payload?.data} col={barganPaymentTermColumns} paginate load={barganPaymentTerm.loading} />
                                    </div>
                                </Col>
                                <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                                    <div className='styleForm'  >
                                        <Form
                                            form={form}
                                            name="basic"
                                            labelCol={{ span: 12 }}
                                        >
                                             <div className='customRow styleFormUpper ' >
                                            {barganPaymentTermObj !== null && !(formState === "add") &&
                                            <div className='customCols slc'>
                                                <Form.Item
                                                    label="ID"
                                                    name="id"
                                                    labelCol={{ span: 15 }}
                                                    wrapperCol={{ span: 14 }}
                                                    initialValue={form.getFieldValue().id}
                                                >
                                                    <Input  size='small' className='styleInput id-field-style' readOnly />

                                                </Form.Item>
                                                </div>
                                            }
                                            <div className='customCols slc'>
                                            <Form.Item
                                                label="Bargan Payment Term Type"
                                                name="barganPaymentTermType"
                                                labelCol={{ span: 15 }}
                                                wrapperCol={{ span: 14 }} 
                                                initialValue={form.getFieldValue().barganPaymentTermType}
                                            >

                                                <Input  size='small'  disabled={!(formState === "add" || formState === "edit")} ref={barganPaymentTermNameInput} onChange={(e) => setBarganPaymentTermName(e.target.value)} className='styleInput' />
                                            </Form.Item>
                                            </div>
                                            <div className='customCols slc'>
                                            <Form.Item
                                                label="Active"
                                                labelCol={{ span: 15 }}
                                                wrapperCol={{ span: 14 }}
                                                name="active"
                                            >
                                                <Checkbox disabled={!(formState === "add" || formState === "edit")} checked={check} onChange={(e) => setCheck(e.target.checked)} />
                                            </Form.Item>
                                            </div>
                                            </div>
                                        </Form>
                                
                                        <Divider />
                                        <div className='styleTab' >
                                            <Tabs type='card' tabBarGutter={2} defaultActiveKey="1" centered onChange={(key) => handleTab(key)}>
                                         
                                                <TabPane tab="Log Info" key="logs"  >
                                                    <div className='tabs' >
                                                        <Tables type="company" scrollX={"50rem"} scroll={360} perPage={15} source={log?.payload?.data} col={logColumns} load={log.loading} paginate />
                                                    </div>
                                                </TabPane>
                                            </Tabs>
                                        </div>
                                   
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                }

            </div>
            {
                minimize &&
                <div className='styleFooter' >
                    <Button className='minimize-button-style' onClick={() => setMinimize(false)}  >Style</Button>
                </div>
            }
        </div >
    )
}